import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RecommendedActionService } from './recommended-action.service';
import { IRecommendedActionObject } from '../shared/models/recommended-action-object.interface';
import { IRecommendedActionSummary } from '../shared/models/recommended-action-summary.interface';

@Component({
    selector: 'dl-device-recommended-action',
    templateUrl: './device-recommended-action.component.html'
})
export class DeviceRecommendedActionComponent implements OnInit {
    public static $name: string = 'deviceRecommendedAction';

    public actions: IRecommendedActionSummary[];

    public actionsLoaded: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IRecommendedActionObject,
        private $mdDialog: MatDialogRef<DeviceRecommendedActionComponent>,
        private recommendedActionService: RecommendedActionService
    ) {
    }

    public ngOnInit() {
        this.recommendedActionService.getActions(this.data.category, this.data.deviceStatusType)
            .then(res => {
                this.data.$actions = res.actions;

                if (this.data.$actions.length === 0) {
                    this.data.$actions.push({
                        description: 'No Recommended Actions!'
                    } as IRecommendedActionSummary);
                }
            })
            .finally(() => this.actionsLoaded = true);
    }

    public cancel() {
        this.$mdDialog.close();
    }
}
